/* eslint-disable no-unused-vars */
import { Button, Label, Table } from '../../../../Components/uielements';
import {
  IconButton,
  ModalButtonWrapper,
  OutlineButton,
  TableCell,
  TableWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalGap, ModalWrapper } from '../premise.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { useUserContext } from '../../../../hooks/UserContext';
import { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import PremiseAlertReceiverService from '../../../../services/bioplus-services/premise-alert-receiver';
import { DeleteIcon } from '../../../../Components/icons';
import AddAlertReceiverToPremiseModal from './addAlertReceiverToPremiseModal';
import ChildModal from '../../../../Components/uielements/modal/childModal';
import { ChildDeleteConfirmationModal } from '../../../../Components/uielements/deleteComfirmationModal/deleteConfirmationModal';

const getAlertReceivers = async (userRole, premiseId, nameFilter, page, pageSize) => {
  switch (userRole.role) {
    // case 'PARTNER':
    //   return await PremiseAlertReceiverService.listByPartner(
    //     userRole.companyId,
    //     premiseId,
    //     nameFilter,
    //     page,
    //     pageSize
    //   );
    case 'CORPORATE_ADMIN':
    case 'OWNER':
    case 'VISITOR':
    case 'MANAGER':
    case 'CONTRACTOR':
    case 'SUPPLIER':
    case 'EMPLOYEE':
    case 'ADMIN':
    case 'PARTNER':
      return await PremiseAlertReceiverService.listForGeofence(
        premiseId,
        nameFilter,
        page,
        pageSize
      );
    default:
      return [];
  }
};

const removeAlertReceiver = async (userRole, geofenceId, userId) => {
  switch (userRole.role) {
    // case 'PARTNER':
    //   return;
    case 'CORPORATE_ADMIN':
    case 'OWNER':
    case 'VISITOR':
    case 'MANAGER':
    case 'CONTRACTOR':
    case 'SUPPLIER':
    case 'EMPLOYEE':
    case 'ADMIN':
    case 'PARTNER':
      return await PremiseAlertReceiverService.removeFromGeofence(geofenceId, userId);
    default:
      return [];
  }
};

const ViewAlertReceivers = ({ onClose, premise, isManager, companyId, invalidateQuery }) => {
  const userContext = useUserContext();
  const userRole = userContext?.company;
  const [nameFilter, setNameFilter] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [removeAlertUser, setRemoveAlertUser] = useState(undefined);
  const [addAlertReceiverToPremise, setAddAlertReceiverToPremise] = useState(undefined);

  const [removingUserId, setRemovingUserId] = useState(undefined);

  const query = useQuery(['alert-receivers', premise?._id, page, pageSize], () =>
    getAlertReceivers(userContext?.company, premise?._id, nameFilter, page, pageSize)
  );

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (args) => removeAlertReceiver(args.userRole, args.geofenceId, args.userId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['alert-receivers'] });
      queryClient.invalidateQueries({ queryKey: [invalidateQuery] });
    },
  });

  const alertReceivers = query?.data;
  // const alertReceiversFormatedData = alertReceivers?.map((item) => ({
  //   ...item,
  //   phone: premise?.contactPhone,
  // }));

  const alertReceiversFormatedData = alertReceivers?.map((item) => {
    const role = item?.userId?.email === userRole?.createdBy ? userRole?.role : '';
    return {
      ...item,
      phone: premise?.contactPhone,
      role: role,
    };
  });

  const isShowDeleteButton = alertReceivers?.length > 1;

  const alertReceiversColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.receiver.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>{`${cellData?.row?.original?.userId?.firstName} ${cellData?.row?.original?.userId?.lastName}`}</TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.receiver.email" />,
        accessor: 'userId.email',
      },
      {
        Header: <IntlMessages id="table.col.mobile.no" />,
        accessor: 'userId.phone',
      },
      {
        Header: <IntlMessages id="table.col.geofence.name" />,
        accessor: 'geofenceId.name',
      },
    ],
    []
  );
  const alertReceiversColumnsWithActions = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.receiver.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>{`${cellData?.row?.original?.userId?.firstName} ${cellData?.row?.original?.userId?.lastName}`}</TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.receiver.email" />,
        accessor: 'userId.email',
      },
      {
        Header: <IntlMessages id="table.col.mobile.no" />,
        accessor: 'userId.phone',
      },
      {
        Header: <IntlMessages id="table.col.geofence.name" />,
        accessor: 'geofenceId.name',
      },
      {
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'role',
        isAction: true,
      },
    ],
    []
  );

  const actionList = [
    (data) => {
      const isThisRowRemoving = mutation.isLoading && removingUserId === data?.userId?._id;
      return (
        <IconButton onClick={() => setRemoveAlertUser(data)} disabled={mutation.isLoading}>
          {isThisRowRemoving ? (
            <IntlMessages id="removing.text" />
          ) : (
            <DeleteIcon style={{ width: '19px', height: '19px' }} />
          )}
        </IconButton>
      );
    },
  ];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  const handleRemoveAlertUser = async (user) => {
    setRemovingUserId(user?.userId?._id);
    try {
      await mutation.mutateAsync({
        userRole: userRole,
        geofenceId: user?.geofenceId?._id,
        userId: user?.userId?._id,
      });
      setRemoveAlertUser(undefined);
    } catch (e) {
      // Keep the confirmation modal open on failure so the user can retry/cancel.
    } finally {
      setRemovingUserId(undefined);
    }
  };

  return (
    <>
      <ChildModal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.text.alert.receiver" />}
      >
        {query.isLoading ? (
          <ModalWrapper>
            <Label>
              <IntlMessages id="loading.text" />
            </Label>
          </ModalWrapper>
        ) : query.isError ? (
          <ModalWrapper>
            <Label>
              <IntlMessages id="error.message" />
            </Label>{' '}
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.cancel" />
            </OutlineButton>
          </ModalWrapper>
        ) : (
          <ModalWrapper>
            <ModalGap>
              <TableWrapper>
                <Table
                  data={alertReceiversFormatedData || []}
                  columns={
                    isShowDeleteButton ? alertReceiversColumnsWithActions : alertReceiversColumns
                  }
                  hasFooter={true}
                  page={page}
                  pageSize={pageSize}
                  prevPage={handlePreviousPage}
                  nextPage={handleNextPage}
                  total={alertReceivers?.length || 0}
                  actions={actionList}
                  EmptyStateText={<IntlMessages id="alert.receiver.empty.state" />}
                  isActionsRenderConditinal={true}
                />
              </TableWrapper>
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose} disabled={mutation.isLoading}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              <Button
                varient="normal"
                onClick={() => setAddAlertReceiverToPremise(premise)}
                disabled={mutation.isLoading}
              >
                <IntlMessages id="modal.button.add.receivers" />
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        )}
      </ChildModal>
      {removeAlertUser && (
        <ChildDeleteConfirmationModal
          onClose={() => setRemoveAlertUser(undefined)}
          message={
            <IntlMessages
              id="delete.comfirmation.text.for.alertUser"
              values={{
                receiver: `${removeAlertUser?.userId?.firstName} ${removeAlertUser?.userId?.lastName}`,
              }}
            />
          }
          onConfirm={() => handleRemoveAlertUser(removeAlertUser)}
          buttonDeleteText={
            mutation.isLoading ? (
              <IntlMessages id="removing.text" />
            ) : (
              <IntlMessages id="modal.button.remove" />
            )
          }
          isConfirmDisabled={mutation.isLoading}
        />
      )}
      {addAlertReceiverToPremise && (
        <AddAlertReceiverToPremiseModal
          onClose={() => setAddAlertReceiverToPremise(undefined)}
          geofence={premise}
          isManager={isManager}
          companyId={companyId}
          invalidateQuery={invalidateQuery}
        />
      )}
    </>
  );
};

export default ViewAlertReceivers;
